import React, {ButtonHTMLAttributes, ReactNode} from 'react';
import classnames from 'classnames';
import {map} from 'lodash';
import Checkmark from 'shared/components/checkmark';

interface ButtonListButton {
  props?: ButtonHTMLAttributes<HTMLButtonElement>;
  onClick: () => void;
  text: ReactNode;
  selected: boolean;
}

interface Props {
  buttons: ButtonListButton[];
}

const ButtonList = ({buttons}: Props) => (
  <ul className="shared-button-list">
    {map(buttons, (button, i) => (
      <li key={`shared-button-list-item-${i}`} className="shared-button-list-item">
        <button
          className={classnames('shared-button-list-button', {selected: button.selected})}
          {...button.props}
          onClick={button.onClick}
        >
          <span className={classnames({'shared-button-list-current': button.selected})}>
            {button.text} {button.selected && <Checkmark />}
          </span>
        </button>
      </li>
    ))}
  </ul>
);

export default ButtonList;
